import React from 'react';
import { Dialog } from 'primereact/dialog';
import './ConfirmationDialog.scss';

interface ConfirmationDialogProps {
    visible: boolean;
    onHide: () => void;
    onConfirm: () => void;
    type: 'cancel' | 'save';
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    visible,
    onHide,
    onConfirm,
    type,
}) => {
    const isCancel = type === 'cancel';

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            closable={false}
            modal
            className="confirmation-dialog"
            showHeader={false}
        >
            <div className="dialog-content">
                {/* Icon */}
                <div className={`dialog-icon ${isCancel ? 'warning' : 'question'}`}>
                    {isCancel ? (
                        <i className="pi pi-exclamation-triangle" />
                    ) : (
                        <i className="pi pi-question" />
                    )}
                </div>

                {/* Title */}
                <h3 className={`dialog-title ${isCancel ? 'warning-title' : 'save-title'}`}>
                    {isCancel ? 'Warning' : 'Save'}
                </h3>

                {/* Message */}
                <p className="dialog-message">
                    {isCancel
                        ? 'All information will be Lost.'
                        : 'All information will be Saved.'}
                    <br />
                    Do you want to proceed?
                </p>

                {/* Buttons */}
                <div className="dialog-actions">
                    <button type="button" className="btn btn-dialog-secondary" onClick={onHide}>
                        <i className={`pi ${isCancel ? 'pi-times-circle' : 'pi-arrow-left'} me-2`} />
                        {isCancel ? 'No' : 'Back'}
                    </button>
                    <button type="button" className="btn btn-dialog-primary" onClick={onConfirm}>
                        <i className="pi pi-check-circle me-2" />
                        {isCancel ? 'Yes' : 'Save'}
                    </button>
                </div>
            </div>
        </Dialog>
    );
};